module.exports = __webpack_public_path__ + "img/weddings_22_V.3ff2b80e.webp";